import appEvents from 'src/modules/10-app/events';
export const handleSigninData = (newState) => {
    appEvents.onLoginSuccess(newState.data);
};
